import React from 'react';
import {prezTime} from '../../util/prez'

import {getCompetitorRowClassName} from '../../util/competitorUtil'

export default (props) =>
    <tr className={ getCompetitorRowClassName( props.competitor)}>
        <td>
            {props.competitor.startNo}
        </td>
        {/* <td className="d-block d-sm-none">{props.competitor.person ? props.competitor.person.firstName + " " + props.competitor.person.lastName : null}</td> */}
        <td className="d-sm-none">{props.competitor.person ? props.competitor.person.firstName + " " + props.competitor.person.lastName : '' } <span className="clubName">{props.competitor.club ? props.competitor.club.name : null}</span></td>
        <td className="d-none d-sm-table-cell">{props.competitor.person ? props.competitor.person.firstName : null}</td>
        <td className="d-none d-sm-table-cell">{props.competitor.person ? props.competitor.person.lastName : null}</td>
        <td className="d-none d-sm-table-cell">{props.competitor.club ? props.competitor.club.name : null}</td>
        <td>{prezTime( props.competitor.startTime)}</td>
        {/* <td>{ moment(props.competitor.startTime, "HH:mm:ss").format("HH:mm") }</td> */}
    </tr>

